<template>
  <form @submit.prevent.stop="submit">
    <div v-if="alerts.length > 0" class="form-group">
      <alert-box
        v-for="alert in alerts"
        :key="alert.message"
        type="danger"
      >
        <span v-html="alert.message" />
      </alert-box>
    </div>
    <div class="form-group">
      <input
        v-model.lazy="newPassword"
        class="form-control new-password"
        placeholder="Password"
        type="password"
        autocomplete="new-password"
      />
    </div>
    <div class="form-group">
      <input
        v-model.lazy="newPasswordConfirmation"
        class="form-control new-password-confirmation"
        placeholder="Password"
        type="password"
        autocomplete="new-password"
      />
    </div>
    <p>
      <submit-button :loading="loading">
        Update Your Password
      </submit-button>
    </p>
  </form>
</template>

<script>
  import axios from 'axios'
  import Cookies from 'js-cookie'
  import alertsMixin from 'mixins/storefront/cart-alerts'
  import SubmitButton from './submit-button'

  export default {
    components: {
      SubmitButton
    },
    mixins: [
      alertsMixin
    ],
    props: {
      url: {
        type: String,
        required: true
      },
      host: {
        type: String,
        required: true
      },
      successMessage: {
        type: String,
        default: 'Password updated!'
      },
      minPasswordLength: {
        type: Number,
        default: 6
      }
    },
    data() {
      return {
        newPassword: null,
        newPasswordConfirmation: null,
        loading: false,
      }
    },
    methods: {
      checkForm() {
        if (this.newPassword.length < this.minPasswordLength) {
          this.alert(
            `Password must be at least ${this.minPasswordLength} characters long`,
            'danger'
          )
        }
        if (this.newPassword !== this.newPasswordConfirmation) {
          this.alert('Password & Password Confirmation must match', 'danger');
        }
        return (this.alerts.length === 0)
      },
      submit() {
        this.alerts = []
        this.loading = true
        if (!this.checkForm()) {
          this.loading = false;
        } else {
          axios.patch(this.url, {
            user: {
              password: this.newPassword,
              password_confirmation: this.newPasswordConfirmation
            }
          }, {
            headers: {
              Accept: 'application/json'
            }
          })
            .then((response) => {
              if (response.status === 200) {
                this.flash(this.successMessage)

                this.redirect('/account')
              } else {
                this.loading = false
                response.data.errors.forEach((error) => {
                  this.alert(error, 'danger')
                })
              }
            })
            .catch((error) => {
              this.loading = false
              if (error.response && error.response.data) {
                error.response.data.errors.forEach((message) => {
                  this.alert(message, "danger")
                })
              } else {
                this.alert(error.message || error, "danger")
              }
            })
        }
      },
      redirect(redirectUrl) {
        window.location.assign(redirectUrl)
      },
      flash(message) {
        Cookies.set('cs_flash_message', message)
      }
    }
  }
</script>
